export const STATUSES = {
    Concept: 1,
    PendingResubmittal: 2,
    WaitingForApproval: 5,
    Approved: 10,
    Rejected: 20,
    Locked: 40,
    Processed: 50,
    Error: 100,
    WaitingForWorkflow: 999,
}

export const ACTIVITYSTATUSES = {
    Concept: 1,
    InProgress: 10,
    Rejected: 20,
    Completed: 50,
    Error: 100,
    WaitingForWorkflow: 999,
}

export const REPORT_TYPES = {
    IGive: 1,
    IReceive: 2,
    IDecline: 3,
}

export const DOSSIER_TYPES = {
    Incident: 1,
    ProcessingActivity: 2,
}